import { combineReducers } from '@reduxjs/toolkit';
import { availableTournamentsSlice } from 'modules/tournaments/store/available-tournaments';
import tourneyChampionship from './championship';
import { bracketsSlice, groupsSlice, stagesSlice } from './stages';

const tourneysReducer = combineReducers({
  championship: tourneyChampionship,
  stages: stagesSlice.reducer,
  groups: groupsSlice.reducer,
  brackets: bracketsSlice.reducer,
  availableTournaments: availableTournamentsSlice.reducer,
});

export default tourneysReducer;
